const radiuses = {
  RADIUS_DEFAULT: 4
}

export default radiuses
